// extracted by mini-css-extract-plugin
export default {"item":"Item_item__WUOrk","icon":"Item_icon__9GzTy","fee":"Item_fee__wGhG2","form":"Item_form__tV7f4","total":"Item_total__REQsS"};